import axios from 'axios'

const parser = new DOMParser();

// DOM
const checkboxes = [...document.querySelectorAll('.js-filterInput')]
const loadMoreButton = document.querySelector('.js-loadMore')
const filterLoader = document.querySelector('.js-filterLoader')
const noResults = document.querySelector('.js-noResults')

// pagination state
let currentPage = 1
let totalPages = null


/**
 * @function queryData
 * @param  {Array} params array of strings - category values
 * @return {Array} collection of posts
 */
const queryData = async (params) => {
    const serializedParams = params.join('%2B')
    const response = await axios.get(`/wp-json/wp/v2/posts?filter[category_name]=${serializedParams}&per_page=10&page=${currentPage}`)

    totalPages = response.headers['x-wp-totalpages'] * 1

    return response.data
}

/**
 * @function getValuesAndHandleInputState
 * @param  {String} currentSelectedValue value of last input interacted with
 * @return {Array} array of category values
 */
const getValuesAndHandleInputState = (currentSelectedValue) => {
    let checkedInputs = [...document.querySelectorAll('.js-filterInput:checked')]
    let checkedValues = checkedInputs.map(checkedInput => checkedInput.value)

    if (currentSelectedValue !== undefined && currentSelectedValue === 'all' && checkedValues.length > 1) {
        checkboxes.forEach(checkbox => {
            if (checkbox.value !== 'all') {
                checkbox.checked = false
            }
        })

        checkedInputs = [...document.querySelectorAll('.js-filterInput:checked')]
        checkedValues = checkedInputs.map(checkedInput => checkedInput.value)
    }
    
    if (currentSelectedValue !== undefined && currentSelectedValue !== 'all' && checkedValues.length > 1 && checkedValues.includes('all')) {
        const allInput = document.querySelector('.js-filterInput[value="all"]')
        allInput.checked = false 

        checkedInputs = [...document.querySelectorAll('.js-filterInput:checked')]
        checkedValues = checkedInputs.map(checkedInput => checkedInput.value)
    }

    if (checkedValues.includes('all') && checkedValues.length === 1) {
        return ['news']
    }

    checkedValues.push('news')

    return checkedValues
}

/**
 * @function renderData
 * @param  {Array} data list of news articles
 * @return {void}
 */
const renderData = (data, append = false) => {
    const listContainer = document.querySelector('.js-newsListContainer')

    if (!append) {
        while (listContainer.firstElementChild) {
            listContainer.firstElementChild.remove()
        }
    }


    data.forEach(newsArticle => {
         let categoryArray = newsArticle.categories
         let brand = ""
         let brandClass = ""
         let brandID = ""
        if(categoryArray.length > 1){
            brandID = categoryArray.filter(getBrandID)
            if (brandID.includes(33)){
                brand = "Gentex"
                brandClass= "gentex"
            } else if(brandID.includes(34)) {
                brand = "Ops-Core"
                brandClass= "opscore"
            }
            else if(brandID.includes(35)) {
                brand = "PureFlo"
                brandClass= "pureflo"
            }

            function getBrandID(brand) {
                return brand > 1;
            }
        } else {
            if (categoryArray[0] == 1) {
                brand = "News"
                brandClass= "news"
            }
        }
        const template = parser.parseFromString(`
            <div class="-row js-listItem">
                <div class="-image">
                    <img src="${newsArticle.fimg_url}" alt="">
                </div>
                <div class="-text">
                    <div class="-category -${brandClass}">
                        <p>${brand}</p>                        
                    </div>
                    <div class="-headline">
                        <a class="-headline-link" href=${newsArticle.link}>${newsArticle.title.rendered}</a>
                    </div>
                    <div class="-arrow">
                        <span>→</span>
                    </div>
                </div>
            </div>
        `, 'text/html')
        listContainer.appendChild(template.querySelector('.js-listItem'))
    })
}

/**
 * @function queryAndRenderData
 * @param  {Array} selectedValues array of categories for filtering news posts
 * @return {Promise}
 */
const queryAndRenderData = async (selectedValues, append = false) => {
    const newsPosts = await queryData(selectedValues)

    if (newsPosts.length < 1) {
        noResults.classList.add('-active')
    } else {
        noResults.classList.remove('-active')
    }

    loadMoreButton.style.display = currentPage >= totalPages ? 'none' : 'block'

    renderData(newsPosts, append)
    console.log(newsPosts)
}

if (checkboxes.length) {
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', async () => {
            filterLoader.classList.add('-active')

            currentPage = 1

            const selectedValues = getValuesAndHandleInputState(checkbox.value)
            await queryAndRenderData(selectedValues)
            filterLoader.classList.remove('-active')
        })
    })

    loadMoreButton.addEventListener('click', async () => {
        loadMoreButton.classList.add('-active')

        currentPage++ 

        const selectedValues = getValuesAndHandleInputState()
        console.log(selectedValues)
        await queryAndRenderData(selectedValues, true)
        loadMoreButton.classList.remove('-active')
    })

    queryAndRenderData(['news'])
}





